/**
 * Owner: Masa Bayu
 * File: TopicDetailPanel.tsx
 * Date:Time: 2026-09-18 12:21
 * Description: Single Tier-1 topic surface — discovery only · quiet empty state.
 */

import { findTopicById, resolveTopicLabel } from '@qx/qxread-core';
import './topics-explorer.css';

export interface TopicDetailPanelProps {
  readonly topicId: string;
  readonly onNavigate: (path: string) => void;
  readonly locale?: string;
}

export function TopicDetailPanel({
  topicId,
  onNavigate,
  locale = 'en',
}: TopicDetailPanelProps) {
  const node = findTopicById(topicId);
  if (node === null) {
    return (
      <section className="market-surface" aria-labelledby="route-title">
        <h2 id="route-title" className="market-surface__title">
          Topic not found
        </h2>
        <p className="market-surface__support">Unknown topic id: {topicId}</p>
        <button
          type="button"
          className="qx-btn qx-btn--secondary"
          onClick={() => {
            onNavigate('/topics');
          }}
        >
          All topics
        </button>
      </section>
    );
  }

  const label = resolveTopicLabel(node, locale);

  return (
    <section className="market-surface" aria-labelledby="route-title">
      <header className="market-surface__hero market-surface__hero--band">
        <p className="market-surface__eyebrow">Topic</p>
        <h2 id="route-title" className="market-surface__title">
          {label}
        </h2>
        <p className="market-surface__support">
          <code className="topics-explorer__id">{node.topicId}</code>
          {' · '}
          Publications classified to this topic will appear here.
        </p>
        <button
          type="button"
          className="qx-btn qx-btn--ghost"
          onClick={() => {
            onNavigate('/topics');
          }}
        >
          ← All topics
        </button>
      </header>
      <p role="status" className="market-surface__empty">
        No publications tagged to this topic yet.
      </p>
      <p className="market-surface__note" role="note">
        Topic ≠ genre · Topic ≠ publication type · Taxonomy ≠ entitlement
      </p>
    </section>
  );
}
